import React from 'react';
import Routes from "./routes";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function App() {
  return (
    <HelmetProvider>
      <Helmet>
        <title>
          Oppdb - Piano-Piano is an ambassador of the repertoire for piano duo.
        </title>
        <meta
          name="Title"
          content="Piano-Piano is an ambassador of the repertoire for piano duo. Discover the piano duo repertoire with Piano-Piano, an ambassador of this dynamic art form."
        />
        <meta
          name="description"
          content="Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee"
        />
        <meta
          name="description"
          content="Find here the 4-hand learning methods, as well as the books for beginners"
        />
        <meta
          name="description"
          content="Find here concertos for 4 hands and orchestra or for 2 pianos and orchestra"
        />
        <meta
          name="description"
          content="Find here the collections which gather several works around a composer or a theme"
        />
        <meta
          name="description"
          content="Find here works composed after 2000"
        />
        <meta
          name="description"
          content="Find here the works that have been played at the Rungis Piano-Piano Festival"
        />
        {/* Twitter meta tags below */}
        <meta name="twitter:card" content="summary" />
        <meta
          name="twitter:image"
          content="https://www.piano-piano.org/wp-content/uploads/2022/09/logo.png"
        />
        <meta
          name="twitter:title"
          content="Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee"
        />
        <meta name="twitter:creator" content="@pianopiano" />
        <meta name="twitter:site" content="@pianopiano" />
        <meta
          name="twitter:description"
          content="Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee"
        />

        {/* Facebook meta tags below */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="www.piano-piano.org/oppdb" />
        <meta
          property="og:title"
          content="Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee"
        />
        <meta
          property="og:description"
          content="Find here the works for 4 hands and for 2 pianos which constitute the great repertoire. The selection is in constant evolution and is a subjective choice of the editorial committee"
        />
        <meta name="keywords" content="Piece,compilation,method,great repertoire,methods,concerto,compilation,contemporain Music, Rungis Piano-Piano Festival,Piano,Piano duo,Repertoire,Ambassador,Discover,Dynamic art form,Explore,Selection,Performances,Compositions,Beauty,Two pianos,Perfect harmony,1 piano 4 hands,2 pianos 4 hands,1 piano 4 hands + ensemble (up to 9 instruments),2 pianos 4 hands + ensemble (up to 9 instruments),1 piano 4 hands + orchestra,2 pianos 4 hands + orchestra,3 pianos 6 hands,3 pianos 6 hands + orchestra" />
        <meta
          property="og:image"
          content="https://www.piano-piano.org/wp-content/uploads/2022/09/logo.png"
        />
      </Helmet>
      <Routes />
    </HelmetProvider>
  )
}
